import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { APISetting } from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import { gsap } from "gsap";

import { EventsManager, FlowEvents, ReelsEvents } from "../../../abstracts/events/EventsManager";
import { Apocalypse } from "../../Apocalypse";
import { fsConfig } from "../../config/ApocalypseConfig";
import { ApocalypseReelsView } from "../../modules/Reels/ApocalypseReelsView";
import { ApocalypseFsContainer } from "../../modules/Reels/fs/ApocalypseFsContainer";
import { ApocalypseFsReel } from "../../modules/Reels/fs/ApocalypseFsReel";
import { ApocalypseCounter } from "../../utils/ApocalypseCounter";
import { fsMatrix } from "../../utils/ApocalypseJSUtils";
import { ApocalypseFsSecondStageDecorator } from "../decorators/ApocalypseFSSecondStageDecorators";
import { ApocalypseFsFirstStageDecorator } from "../decorators/ApocalypseFsFirstStageDecorator";
import { ApocalypseNormalResultPresentation } from "../normal/ApocalypseNormalResultPresentation";

export class ApocalypseFreespinResultPresentation extends ApocalypseNormalResultPresentation {
    private fsFinalDataReels: string[][];
    private fsContainer: ApocalypseFsContainer;
    protected fsLeftCounter: ApocalypseCounter;

    constructor(id: string = `ApocalypseFreespinResultPresentation`) {
        super(id);
    }

    protected override handleEvents() {
        EventsManager.on(ReelsEvents.GET_FREESPIN_REELS, (fsReels: ApocalypseFsReel[]) => {
            this.reels = fsReels;
        });

        EventsManager.on(ReelsEvents.GET_REELS_VIEW, (reelsView: ApocalypseReelsView) => {
            this.reelsView = reelsView;
            this.fsContainer = reelsView.getFreespinContainer();
            this.fsLeftCounter = this.fsContainer.fsLeftContainer.counter;
        });
    }

    protected override handleFinishAnimation(): void {
        this.flowPresentationTimeline = gsap.timeline({
            onStart: () => {},
        });

        ////////////////////////

        const hasSkipActive =
            SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN, false) || this.skipInitialized;

        const stopDelay = hasSkipActive ? fsConfig.skipReelsDelay : fsConfig.stopSpinReelDelay;

        // ! fsFinalDataReels should be removed once fs is implemented completely. model.currentsymbols should be used as finalDataReels
        this.fsFinalDataReels = [];
        const reversedEvaluatedArea = fsMatrix(this.model.data.evaluatedArea);
        // if (Apocalypse.model.gameData.firstStage) {
        reversedEvaluatedArea.forEach((reel: string[]) => {
            reel.forEach((symbolName: string) => {
                this.fsFinalDataReels.push([symbolName]);
            });
        });

        const fsInitialDataReels: string[][] = [];
        const reversedInitialDataReels = fsMatrix(this.model.data.reels);

        reversedInitialDataReels.forEach((reel: string[]) => {
            reel.forEach((symbolName: string) => {
                fsInitialDataReels.push([symbolName]);
            });
        });

        if (Apocalypse.model.data.firstStage) {
            ApocalypseFsFirstStageDecorator({
                finalDataReels: this.fsFinalDataReels,
                initialDataReels: fsInitialDataReels,
                gameReels: this.reels,
                timeline: this.flowPresentationTimeline,
                stopSpinDelay: stopDelay,
                wasFeatureBuy: this.model.gameData.wasFeatureBuy || this.model.data.enhancedBet,
                playSoundDelay: 0.18,
                onDecoratorComplete: this.handleFeatures.bind(this),
                reelsContainer: this.fsContainer,
            });
        } else {
            ApocalypseFsSecondStageDecorator({
                flowStateController: this.controller,
                finalDataReels: this.fsFinalDataReels,
                gameReels: this.reels,
                timeline: this.flowPresentationTimeline,
                stopSpinDelay: stopDelay,
                wasFeatureBuy: this.model.gameData.wasFeatureBuy || this.model.data.enhancedBet,
                playSoundDelay: 0.18,
                onDecoratorComplete: this.handleFeatures.bind(this),
                reelsContainer: this.fsContainer,
            });
        }

        if (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            this.skip();
        }
    }

    protected skip(): void {
        super.skip();

        const skipFactor = fsConfig.skipCurrentSymbolsTimeScale!;
        this.flowPresentationTimeline.timeScale(skipFactor);

        EventsManager.trigger(FlowEvents.SKIP_NORMAL_BET);
    }

    protected override onDefaultStart() {
        super.onDefaultStart();
    }

    protected handleFeatures() {
        this.initializeTimeline();

        let freespinsLeft = this.model.data.firstStage
            ? this.model.data.freespinsLeft
            : this.model.data.secondStageFsLeft;

        freespinsLeft = this.model.data.secondStage
            ? this.model.data.secondStageFsLeft
            : freespinsLeft;

        if (freespinsLeft > 0) {
            this.flowPresentationTimeline.add(
                this.fsLeftCounter.getUpdateCounterTextAnimation(freespinsLeft)
            );

            // this.flowPresentationTimeline.call(() => {
            //     this.keypad.setZeroBetSpinCounter(freespinsLeft);
            // });
        }

        this.flowPresentationTimeline.resume();
    }
}
